import { useQuery } from '@tanstack/react-query';

import { ESHOP_QUERY_KEY } from '@telialt/core-eshop/src/model';

import { apiGetCategoryData } from '../store/api';

/**
 * Fetch category data
 * @param {string} path - The path of the category
 * @param {string} segment - The segment of the category
 */
export const useCategoryQuery = (path: string, segment: string) => {
    const {
        data: categoryData,
        isLoading: categoryDataIsLoading,
        error: categoryDataError,
    } = useQuery({
        queryKey: [ESHOP_QUERY_KEY.PRODUCT_CATEGORY, path, segment],
        queryFn: async ({ signal }) => (await apiGetCategoryData(path, segment, signal)).data,
    });

    return {
        categoryData,
        categoryDataIsLoading,
        categoryDataError,
    };
};
